export enum JobseekerDocumentTypeEnum{
    Other = 1,
    ResumeOrCv = 2,
    DiplomaOrCertificate = 3,
    RecommendationLetter = 4,
    Portfolio = 5,
}